
const data = [
  {
    title: 'IT治理概述',
    description: 'IT治理关注过程管理及业务目标的满足。企业信息系统通过IT过程管理信息化资源，在实现IT运营目标的同时，满足企业业务需求。'
  },
  {
    title: '服务内容',
    description: '信息化标准体系建设\n' +
      '信息化管理体系建设\n' +
      '业务与IT协同机制建设\n' +
      'IT组织运作体系建设'
  },
  {
    title: '服务特点',
    description: '云恋科技强调通过IT治理，整合和优化IT资源，最终实现企业业务需求。\n' +
      '降低复杂IT系统带来的业务风险；\n' +
      '支持业务流程优化；\n' +
      '持续推动IT系统健康运转；\n' +
      '协助提升企业开拓新业务的能力。'
  }
];

export default data;


// WEBPACK FOOTER //
// ./src/routes/Service/config/it-manage.js